export const SUBSCRIPTION_GROUPS_KEY = "/engagement/:app_group_id/line_subscription_groups" as const;
